import { useCallback, useEffect, useState, } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid, MenuItem } from "@mui/material";

/** COMPONENT */
import TableCustom from "../../../component/table/tableCustom";
import InputTextField from "../../../component/input/inputTextField";
import FilterSelect from "../../../component/select/filterSelect";
import HeaderCard from "../../../component/cardCustom/headerCard";
import TableRowCommon from "../../../component/table/TableRowCommon";
import ButtonCustom from '../../../component/button/buttonCustom';
import ModalCustom from "../../../component/modalCustom/modalCustom";

/** STYLE */
import * as Style from "./userDefault.style"

/** API */
import { swalActive } from "../../../component/notification/swal";
import { useDispatch } from "react-redux";
import { resetModal, showModal, submitModal, unSubmitModal } from "../../../app/slice/modal.slice";
import { notiError, notiSuccess } from "../../../component/notification/notifications";
import RelationshipsApi from "../../../api/setting/relationship/relationship.api";
import { icons } from "../../../constants/images";
import { isCreate, isDelete, isUpdate, isView } from "../../../utils/permission.utils";
import { Col, Row } from "react-bootstrap";

const initStateErrorMessage = {
  RELASHIONSHIP_NAME_TH: ``,
  IS_DUPLICATE_RELASHIONSHIP_NAME_TH: ``,
  RELASHIONSHIP_NAME_TH_STRING_BASE: ``,
  RELASHIONSHIP_NAME_TH_STRING_EMPTY: ``,
  RELASHIONSHIP_NAME_TH_MAXIMUM_LENGTH: ``,
  RELASHIONSHIP_NAME_TH_ANY_REQUIRED: ``,

  RELASHIONSHIP_NAME_EN: ``,
  IS_DUPLICATE_RELASHIONSHIP_NAME_EN: ``,
  RELASHIONSHIP_NAME_EN_STRING_BASE: ``,
  RELASHIONSHIP_NAME_EN_STRING_EMPTY: ``,
  RELASHIONSHIP_NAME_EN_MAXIMUM_LENGTH: ``,
  RELASHIONSHIP_NAME_EN_ANY_REQUIRED: ``
}

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

export default function UserRelationships() {

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [errorMessage, setErrorMessage] = useState<any>(initStateErrorMessage)
  const [relationshipsId, setRelationshipsId] = useState(Number)
  const [relationshipsNameTh, setRelationshipsNameTh] = useState<string>('')
  const [relationshipsNameEn, setRelationshipsNameEn] = useState<string>('')
  const [relationshipsStatus, setRelationshipsStatus] = useState<string>('ACTIVE')
  const [relationshipsData, setRelationshipsData] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(5)
  const [rowCount, setRowCount] = useState<number>()
  const [sortBy, setSortBy] = useState<string>('modifiedDate')
  const [sortType, setSortType] = useState<string>('ASC')
  const [search, setSearch] = useState<string>('')
  const [status, setStatus] = useState<string>('ALL')

  const loadData = useCallback(async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await RelationshipsApi.findAll(condition)

    if (res.status === 200) {
      setRowCount(res.headers['total'])
      setRelationshipsData(res.data)


    } else {
      setRowCount(0)
      setRelationshipsData([])
    }
  }, [page, pageLimit, search, sortBy, sortType, status])


  useEffect(() => {
    loadData()
  }, [loadData])

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageLimitChange = (newPageLimit: number) => {
    setPageLimit(newPageLimit);
  };

  const handleChangeStatus = (newStatus: string) => {
    setStatus(newStatus)

  }

  const onRequestSort = (sortBy: string, sortType: string) => {
    setSortType(sortType)
    setSortBy(sortBy)
  }

  const headCells = [
    { id: "relationshipsId", disablePadding: false, label: "NO" },
    { id: "relationshipsNameTh", disablePadding: false, label: t("RELASHIONSHIP.HEADCELL.RELASHIONSHIPNAMETH"), sortable: true },
    { id: "relationshipsNameEn", disablePadding: false, label: t("RELASHIONSHIP.HEADCELL.RELASHIONSHIPNAMEEN"), sortable: true },
    { id: "status", disablePadding: false, align: 'center', label: t("RELASHIONSHIP.HEADCELL.STATUS"), sortable: true },
    { id: "modifiedId", disablePadding: false, align: 'center', label: t("RELASHIONSHIP.HEADCELL.MODIFIEDBY"), sortable: true },
    { id: "action", disablePadding: false, label: t("RELASHIONSHIP.HEADCELL.ACTION") }
  ];

  const onActive = (id: number, valueStatus: string) => {
    swalActive(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('RELASHIONSHIP.ALERT.CONFIRM_STATUS')}</p>`,
      null, (res: any) => {
        if (res) {
          RelationshipsApi.updateStatus(id, valueStatus)
            .then((res) => {
              notiSuccess(t('RELASHIONSHIP.MESSAGE.SUCCESS.UPDATE_STATUS'), '', null, null)

              loadData()
            })
            .catch((e) => {
              notiError(t('RELASHIONSHIP.MESSAGE.ERROR'), '', null, null)

            })
        }
      })
  }
  const onDelete = (data: any) => {
    const { relationshipsId, relationshipsNameTh, relationshipsNameEn } = data

    swalActive(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('RELASHIONSHIP.ALERT.CONFIRM_DELETE')}</p>`,
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('RELASHIONSHIP.ALERT.CONFIRM_DELETE', {
        relationshipsNameTh: relationshipsNameTh, relationshipsNameEn: relationshipsNameEn ? ' ' + relationshipsNameEn + '' : ''
      })}</p>`,
      (res: any) => {
        if (res) {
          RelationshipsApi.delete(relationshipsId)
            .then((res) => {
              notiSuccess(t('RELASHIONSHIP.MESSAGE.SUCCESS.DELETE'), '', null, null)
              loadData()
            })
            .catch((e) => {
              notiError(t('RELASHIONSHIP.MESSAGE.ERROR'), '', null, null)
            })
        }
      }
    )
  }

  const onEdit = (data: any) => {
    const { relationshipsId, relationshipsNameTh, relationshipsNameEn, status } = data
    setRelationshipsId(relationshipsId)
    setRelationshipsNameTh(relationshipsNameTh)
    setRelationshipsNameEn(relationshipsNameEn)
    setStatus(status)
    dispatch(showModal())
  }

  const resetForm = () => {
    setRelationshipsId(0)
    setRelationshipsNameTh('')
    setRelationshipsNameEn('')
    setRelationshipsStatus('ACTIVE')
    clearErrorMessage()
  }

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1

    const { relationshipsId, relationshipsNameTh, relationshipsNameEn, modifiedBy, modifiedDate, status } = objData;

    const statusBtnActive = status === "ACTIVE" ? true : permissions.isUpdate.disabled;
    const statusBtnInActive = status === "INACTIVE" ? true : permissions.isUpdate.disabled;
    const objRenderData = {
      key: relationshipsId,
      id: relationshipsId,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: no },
        { option: "TEXT", align: "left", label: relationshipsNameTh || "-" },
        { option: "TEXT", align: "left", label: relationshipsNameEn || "-" },
        { option: "STATUS", align: "center", label: status || "-" },
        {
          option: "UPDATE_BY", align: "left", label: { updatedBy: `${(modifiedBy && (modifiedBy.firstname && modifiedBy.lastname)) ? modifiedBy.firstname + ' ' + modifiedBy.lastname : modifiedBy?.firstname || modifiedBy?.lastname || '-'}`, updatedAt: modifiedDate }
        },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ],

    };
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => onActive(Number(objRenderData.id), 'ACTIVE')}
        oninactive={() => onActive(Number(objRenderData.id), 'INACTIVE')}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => onDelete(objRenderData.obj)}
      />
    )
  };


  const submit = () => {
    if (!relationshipsNameTh) return setErrorMessage({ ...errorMessage, ...{ RELASHIONSHIP_NAME_TH: t('RELASHIONSHIP.MESSAGE.RELASHIONSHIP_NAME_TH') } })
    if (!relationshipsNameEn) return setErrorMessage({ ...errorMessage, ...{ RELASHIONSHIP_NAME_EN: t('RELASHIONSHIP.MESSAGE.RELASHIONSHIP_NAME_EN') } })

    dispatch(submitModal())
    RelationshipsApi.create(relationshipsNameTh, relationshipsNameEn)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('RELASHIONSHIP.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({
            ...errorMessage,
            ...{
              [err.error_description]: t(`RELASHIONSHIP.MESSAGE.${err.error_description}`)
            }
          })
          if (err.statusCode === 400) {
            if (err.error_description === t('RELASHIONSHIP.MESSAGE.IS_DUPLICATE_RELASHIONSHIP_NAME_TH')) {
              setErrorMessage({
                ...errorMessage,
                ...{
                  RELASHIONSHIP_NAME_TH: t(`${t(err.error_description)}`),

                }
              })
            } else if (err.error_description === t('RELASHIONSHIP.MESSAGE.IS_DUPLICATE_RELASHIONSHIP_NAME_EN')) {
              setErrorMessage({
                ...errorMessage,
                ...{
                  RELASHIONSHIP_NAME_EN: t(`${t(err.error_description)}`),

                }
              })
            }

          }
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.error_description]: t(`RELASHIONSHIP.MESSAGE.${err.error_description}`) } })
        if (err.statusCode === 400) {
          if (err.error_description === t('RELASHIONSHIP.MESSAGE.IS_DUPLICATE_RELASHIONSHIP_NAME_TH')) {
            setErrorMessage({
              ...errorMessage,
              ...{
                RELASHIONSHIP_NAME_TH: t(`${t(err.error_description)}`),

              }
            })
          } else if (err.error_description === t('RELASHIONSHIP.MESSAGE.IS_DUPLICATE_RELASHIONSHIP_NAME_EN')) {
            setErrorMessage({
              ...errorMessage,
              ...{
                RELASHIONSHIP_NAME_EN: t(`${t(err.error_description)}`),

              }
            })
          }

        }
        dispatch(unSubmitModal())
      })

  }

  const submitEdit = () => {
    if (!relationshipsNameTh) return setErrorMessage({ ...errorMessage, ...{ RELASHIONSHIP_NAME_TH: t('RELASHIONSHIP.MESSAGE.RELASHIONSHIP_NAME_TH') } })
    if (!relationshipsNameEn) return setErrorMessage({ ...errorMessage, ...{ RELASHIONSHIP_NAME_EN: t('RELASHIONSHIP.MESSAGE.RELASHIONSHIP_NAME_EN') } })

    dispatch(submitModal())
    RelationshipsApi.update(relationshipsId, { relationshipsNameTh, relationshipsNameEn, status: relationshipsStatus })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 205) {
          notiSuccess(t(`RELASHIONSHIP.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.error_description]: t(`RELASHIONSHIP.MESSAGE.${err.error_description}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.error_description]: t(`RELASHIONSHIP.MESSAGE.${err.error_description}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  return (
    <>
      <HeaderCard text={t("RELASHIONSHIP.TITLE")} />
      <Style.MainContainer>
        <Box>
          <Row spacing={2}>
            <Col lg={3} md={6} xs={12} className="my-1">
              <InputTextField label={t("RELASHIONSHIP.INPUT.SEARCH")}
                value={search}
                onchange={(event) => {
                  setSearch(event.target.value)
                  setPage(1)
                }}
              />
            </Col>
            <Col lg={3} md={6} xs={12} className="my-1">
              <FilterSelect
                onchange={(event) => {
                  const value = event.target.value
                  if (value) {
                    handleChangeStatus(value)
                    setPage(1)
                  }
                }}
                renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                label={t('STATUS.LABEL')}
                selectId="select-status"
                value={status}
                labelId="label-status"
                options={[
                  <MenuItem key="1" value="ALL">
                    {t('STATUS.ALL')}
                  </MenuItem>,
                  <MenuItem key="2" value="ACTIVE">
                    {t('STATUS.ACTIVE')}
                  </MenuItem>,
                  <MenuItem key="3" value="INACTIVE">
                    {t('STATUS.INACTIVE')}
                  </MenuItem>
                ]}
              />
            </Col>
            <Col lg={3} md={6} xs={12} ></Col>
            <Col lg={3} md={6} xs={12} className="my-1">
            <ButtonCustom style={{ width: '100%' }}
                  disabled={permissions.isCreate.disabled}
                  type="button"
                  textButton={t('RELASHIONSHIP.BUTTON.ADD')}
                  endIcon={<img src={icons.add} />}
                  onClick={() => dispatch(showModal())}
                />
            </Col>

          </Row>
        </Box>
        <Style.TableContainer>

          <TableCustom
            headCells={headCells}
            customScroll
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            rowCount={rowCount}
            rowsData={relationshipsData.map((data: any, index: number) => {
              return renderData(data, index);
            })}
            onSort={onRequestSort}
            setPageLimit={handlePageLimitChange}
            setPage={handlePageChange}

          />
        </Style.TableContainer>

      </Style.MainContainer>

      <ModalCustom
        title={relationshipsId ? t('RELASHIONSHIP.TITLE_UPDATE') : t('RELASHIONSHIP.TITLE_CREATE')}
        component={
          <div className="pb-2">
            <InputTextField
              onchange={(event) => {
                setRelationshipsNameTh(event.target.value)
                clearErrorMessage()
              }}
              value={relationshipsNameTh}
              helperText={
                errorMessage.RELASHIONSHIP_NAME_TH ||
                errorMessage.IS_DUPLICATE_RELASHIONSHIP_NAME_TH ||
                errorMessage.RELASHIONSHIP_NAME_TH_STRING_BASE ||
                errorMessage.RELASHIONSHIP_NAME_TH_STRING_EMPTY ||
                errorMessage.RELASHIONSHIP_NAME_TH_MAXIMUM_LENGTH ||
                errorMessage.RELASHIONSHIP_NAME_TH_ANY_REQUIRED
              }
              required={true}
              style={{ marginBottom: '1rem' }}
              heading={t('RELASHIONSHIP.INPUT.RELASHIONSHIP_NAME_TH')}
            />
            <InputTextField
              key="relashionshipsNameEn"
              onchange={(event) => {
                setRelationshipsNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={relationshipsNameEn}
              helperText={
                errorMessage.RELASHIONSHIP_NAME_EN ||
                errorMessage.IS_DUPLICATE_RELASHIONSHIP_NAME_EN ||
                errorMessage.RELASHIONSHIP_NAME_EN_STRING_BASE ||
                errorMessage.RELASHIONSHIP_NAME_EN_STRING_EMPTY ||
                errorMessage.RELASHIONSHIP_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.RELASHIONSHIP_NAME_EN_ANY_REQUIRED
              }
              required={true}
              heading={t('RELASHIONSHIP.INPUT.RELASHIONSHIP_NAME_EN')}
            />
            <div className="mt-3">
              <FilterSelect
                heading={`${t('STATUS.LABEL')}`}
                onchange={(event) => {
                  const value = event.target.value
                  if (value) {
                    setRelationshipsStatus(value)
                  }
                }}
                renderValue={() => `${t(`STATUS.${relationshipsStatus}`)}`}
                label={t('STATUS.LABEL')}
                selectId="select-status-update"
                value={status}
                labelId="label-status-update"
                options={[
                  <MenuItem key="1" value="ACTIVE">
                    {t('STATUS.ACTIVE')}
                  </MenuItem>,
                  <MenuItem key="2" value="INACTIVE">
                    {t('STATUS.INACTIVE')}
                  </MenuItem>
                ]}
              />
            </div>
          </div>
        }
        onReset={resetForm}
        onSubmit={relationshipsId ? submitEdit : submit}
        textBtnCancel={t('RELASHIONSHIP.BUTTON.CANCEL')}
        textBtnConfirm={t('RELASHIONSHIP.BUTTON.SAVE')}
      />

    </>
  );
}
